import React, { useCallback, useEffect, useState } from "react";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import "../css/others/Table.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import { useParams, useNavigate } from "react-router-dom";
import { CampaignProjectHistory } from "../interFaces/interfaces";
const CampaignAndProjectHistory: React.FC = () => {
  const { campaignId } = useParams<{ campaignId: string }>();
  const navigate = useNavigate();
  const [data, setData] = useState<CampaignProjectHistory[]>([]);
  const [, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const columns = [{ key: "projectId", label: "Project ID" }, { key: "projectName", label: "Project Name" }, { key: "campaignName", label: "Campaign Name" },];
  const fetchHistory = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiCall("get", `/api/campaign-projects/history/${campaignId}?page=${currentPage - 1}&size=${itemsPerPage}`);
      setData(response?.content || []);
      setTotalPages(response?.totalPages || 0);
      setTotalElements(response?.totalElements || 0);
    } catch (error) {
      console.error("Error fetching campaign project history:", error);
    } finally {
      setLoading(false);
    }
  }, [campaignId, currentPage, itemsPerPage]);
  const fetchAllData = async (): Promise<CampaignProjectHistory[]> => {
    try {
      const response = await apiCall("get", `/api/campaign-projects/history/${campaignId}?page=${currentPage - 1}&size=${itemsPerPage}`);
      return response?.content || [];
    } catch (error) {
      console.error("Export failed:", error);
      return [];
    }
  };
  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);
  const handleNavigate = (campaignId: string, projectId: string) => {
    navigate(`/campaignprojecthistorydetails/${campaignId}/${projectId}`);
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Campaign Project History</h2>
        <div className="table-title-actions">
          <ExportButton data={data} columns={columns} fetchAllData={fetchAllData} fileName="campaign_project_history" />
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item) => (
                  <tr key={item.id}>
                    <td className="clickable" onClick={() => handleNavigate(item.campaignId, item.projectId)}>{item.projectId || "N/A"}</td>
                    <td>{item.projectName || "N/A"}</td>
                    <td>{item.campaignName || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="no-data">No Campaign And Project History Found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
    </div>
  );
};
export default CampaignAndProjectHistory;